import React, { FC } from 'react';
import { Template } from 'api/reports/csat';
import { PageLoading } from 'components/atoms/loading';
import { Page } from 'components/molecules/page';
import { CSATOverview } from 'components/organisms/csat/overview';
import { useUser } from 'hooks/use-user';
import { useTemplatesQuery } from 'queries';
import { useUsersQuery } from 'queries/members';

export const CsatPage: FC = () => {
  const { projects } = useUser();
  const { data: templates, isLoading: isTemplatesLoading } =
    useTemplatesQuery();
  const { data: users, isLoading: isUsersLoading } = useUsersQuery();

  const isLoading = isTemplatesLoading || isUsersLoading;

  return (
    <Page $gray>
      <Page.Content>
        {isLoading ? (
          <PageLoading size="large" />
        ) : (
          templates &&
          projects &&
          users && (
            <CSATOverview
              templates={templates as Template[]}
              users={users}
              projects={projects}
            />
          )
        )}
      </Page.Content>
    </Page>
  );
};
